const initBookingFormStickyEffect = () => {
  //if screen > 1024px (lg breakpoint) : apply the sticky-like effect to the booking form
  //otherwise, the booking form should be static with an auto width
  if(window.matchMedia("(min-width: 1024px)").matches){
    const bookingForm = document.getElementById('booking-form');
    const bookingFormWrapper = bookingForm.closest('.booking-form-wrapper');
    bookingForm.style.width = bookingFormWrapper.clientWidth + 'px';

    const collisionDiv = document.getElementById('collision-block');
    let initialOffsetTop = bookingForm.offsetTop;
    let offset = 100;
    window.addEventListener('scroll', function() {
      if(window.matchMedia("(min-width: 1024px)").matches){
        let scrollY = window.scrollY + offset;
        let collisionTop = collisionDiv.offsetTop - bookingForm.offsetHeight;

        if (scrollY >= initialOffsetTop && scrollY <= collisionTop) {
          bookingForm.style.position = 'fixed';
          bookingForm.style.top = '100px';
        }
        else if (scrollY > collisionTop) {
          bookingForm.style.position = 'absolute';
          bookingForm.style.top = collisionTop + 'px';
        }
        else {
          bookingForm.style.position = 'static';
        }
      }
    });

    window.addEventListener('resize', () => {
      if(!(window.matchMedia("(min-width: 1024px)").matches)){
        bookingForm.style.width = 'auto';
        bookingForm.style.position = 'static';
      }
      else{
        bookingForm.style.width = bookingFormWrapper.clientWidth + 'px';
      }
    });
  }
}

export { initBookingFormStickyEffect }
